import { CircleStackIcon } from "@heroicons/react/24/outline";
import { cn } from "helpers/classNames";

type Props = {
  className?: string;
};

export const SeparatorIcon = ({ className }: Props) => (
  <CircleStackIcon className={cn("h-4 w-4 text-gray-400", className)} />
);
